import {
	PLAYABLE_SOUNDS,
	type PlayableSound,
} from "@client/app/hooks/playableSounds";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type SoundStore = {
	events: Partial<Record<PlayableSound, boolean>>;
	setEventEnabled: (sound: PlayableSound, enabled: boolean) => void;
	setAllEventsEnabled: (enabled: boolean) => void;
	isSoundEnabled: (sound: PlayableSound) => boolean;
};

function allEvents(enabled: boolean): Record<PlayableSound, boolean> {
	return Object.fromEntries(
		PLAYABLE_SOUNDS.map((sound) => [sound, enabled]),
	) as Record<PlayableSound, boolean>;
}

export const useSoundStore = create<SoundStore>()(
	persist(
		(set, get) => ({
			events: {},
			setEventEnabled: (sound, enabled) =>
				set((state) => ({
					events: { ...state.events, [sound]: enabled },
				})),
			setAllEventsEnabled: (enabled) =>
				set({ events: allEvents(enabled) }),
			isSoundEnabled: (sound) => get().events[sound] !== false,
		}),
		{
			name: "capitalisto-sound-prefs",
			partialize: (state) => ({ events: state.events }),
		},
	),
);
